import React, { useEffect } from "react";
import Header from "../../components/appLayout/header";
import { Col, Row } from "react-bootstrap";
import { ButtonApp } from "../../components/ButtonApp";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.scss";
export const Services = () => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate("/contact#contact-section");
  };
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#services-section") {
      const el = document.getElementById("services-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <div>
      {" "}
      <div className="slide-services">
        <div className="header-services pt-5">
          <Header />
        </div>
        <div className="slide-services-container  ">
          <Row className="align-items-center justify-content-center gx-0  h-100 mb-5">
            <Col md={6} className="mt-5 mb-5">
              <h1 className="slide-title  mt-5">
                Une expertise complète,
                <br /> un seul cabinet de conseil
              </h1>
              <div className="descri-slide-mobile">
                <p className="text-slide mt-3 mb-5">
                  Chez Consultek, nous combinons vision stratégique, innovation
                  digitale et exécution sur-mesure.
                  <br />
                  Nos 4 pôles d’expertise sont conçus pour fonctionner de
                  manière autonome ou complémentaire, selon les besoins
                  spécifiques de chaque client.
                </p>
                <ButtonApp
                  title={"Contactez-nous"}
                  handlClick={handleNavigation}
                />
              </div>
            </Col>
            <Col md={6}></Col>
          </Row>
        </div>
      </div>
      <div id="services-section" className="services-lists">
        <ul className="services-list">
          <li
            onClick={() => {
              navigate("/consulting");
              window.scrollTo(0, 0);
            }}
          >
            01.Consulting Stratégique
          </li>
          <li
            onClick={() => {
              navigate("/developpement");
              window.scrollTo(0, 0);
            }}
          >
            02.Développement Web
          </li>
          <li
            onClick={() => {
              navigate("/marketing");
              window.scrollTo(0, 0);
            }}
          >
            03.Marketing Digital
          </li>
          <li
            onClick={() => {
              navigate("/design");
              window.scrollTo(0, 0);
            }}
          >
            04.Design Graphique
          </li>
        </ul>
      </div>
    </div>
  );
};
